import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { of, Observable, throwError } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

import moment from 'moment';

@Component({
  selector: 'folders-breadcrumbs',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit, OnChanges {
  @Input() public path: any[] = [];
  @Input() public stopAt;
  public displayPath: any[] = [];
  public dropDownPath: any[] = [];

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.stopAt) {
      const stopAtIndex = this.path.findIndex((item) => item.id === this.stopAt);

      if (stopAtIndex) {
        this.path = this.path.slice(stopAtIndex);
      }
    }
    if (this.path.length > 4) {
      let sliceIndex = this.path.length - 4;
      this.displayPath = this.path.slice(sliceIndex) as any;
      this.dropDownPath = this.path.slice(0, sliceIndex) as any;
    } else {
      this.displayPath = this.path;
      this.dropDownPath = [];
    }
  }
}
